import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHR = styled.hr`
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-bottom: 0;
  margin: 0;
`;

const MenuLine = ({ className }) => (
  <StyledHR className={className} />
);

MenuLine.defaultProps = {
  className: '',
};

MenuLine.propTypes = {
  className: PropTypes.string,
};

export default MenuLine;
